import { request } from "leatherman-js";

const termMap = {
  monthly: 1,
  annually: 12,
};

const checkout = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async validateCoupon(context, { amount, couponCode, term, packageId }) {
      const data = {
        amount,
        couponCode,
        term: termMap[term],
        packageId: packageId,
      };
      const discountAmount = await request.makeParse("validateCoupon", {}, data);

      return amount - discountAmount;
    },
  },
};

export default checkout;
